import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JoinPipe } from './join.pipe';
import { EditorComponent } from './editor/editor.component';
import { PaginationComponent } from './pagination/pagination.component';
import {PaginationService} from './pagination.service';
import { FilesizePipe } from './filesize.pipe';
import { LimitPipe } from './limit.pipe';
import { PasswordComponent } from './password/password.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
      FormsModule
  ],
  declarations: [JoinPipe, EditorComponent, PaginationComponent, FilesizePipe, PasswordComponent, LimitPipe],
    exports: [JoinPipe, EditorComponent, PaginationComponent, PasswordComponent, FilesizePipe, LimitPipe],
    providers: [PaginationService]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts